
import 'core-js/es/map';
import 'core-js/es/set';
import 'raf/polyfill';


import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import './ie.css';



import App from './App';
// import registerServiceWorker from './registerServiceWorker';
import { BrowserRouter } from 'react-router-dom'

import "./fonts/fonts.css";

window.matchMedia = window.matchMedia || (() => { return { matches: false, addListener: () => {}, removeListener: () => {}, }; });
// const browserHistory = {};

// const basename = "/go-israel-new/";
const basename = "/";

ReactDOM.render(
	<BrowserRouter basename={basename} forceRefresh={true} >
		<App />
	</BrowserRouter>
	, document.getElementById('root'));
// registerServiceWorker();





// WEBPACK FOOTER //
// ./src/index.js